var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn",class:{ 'btn-danger': _vm.danger, 'btn-warning': _vm.warning },attrs:{"disabled":_vm.disabled,"color":"grey"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }